import { Http } from '../axios/interceptors'

export const allWhitheListByCompany = async (param) => Http('GET', `/WhiteList/GetByCompany?`, param)

export const getWhitheList = async id => Http('GET', `/WhiteList/Get?idWhiteList=${id}`)

export const createOrEditWhitheList = async (body, id = null) => (id ? Http('PUT', `/WhiteList/Update`, null, body) : Http('POST', '/WhiteList/Create', null, body))

export const deleteWhitheList = async guid => Http('DELETE', `/WhiteList/Delete?idWhiteList=${guid}`)
